import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'community-comment',
    templateUrl: './community-comment.component.html',
    styleUrls: ['./community-comment.component.scss']
})
export class CommunityCommentComponent implements OnInit, OnDestroy {

    comment: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private communityService: CommunityService
    ) {
    }

    ngOnInit() {
        let commentId: any = this.route.snapshot.paramMap.get('commentId');
        this.progressIndicatorService.progress = true;
        this.communityService.getComment(commentId).subscribe({
            next: (value: any) => {
                console.log('CommunityCommentComponent.ngOnInit.communityService.getComment.value', value);
                this.progressIndicatorService.progress = false;
                this.comment = value;
            },
            error: (error: any) => {
                console.log('CommunityCommentComponent.ngOnInit.communityService.getComment.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    ngOnDestroy() {
    }

    updateUser(user: any) {
        if (this.comment.user.id == user.id) {
            this.comment.user.banned = user.banned;
        }
    }

    navigateToCommunity() {
        this.router.navigate(['/community']);
    }
}
